import React, { useState, useEffect, useRef } from "react";
import globeImage from "../assets/mapImage.avif";

import "../css/customerManager.css";
import ActivityChart from "../components/common/ActivityChart";
import StatsCard from "../components/customerManager/Stats";
import CustomerTable from "../components/customerManager/CustomerTable";
import PageHeader from "../components/customerManager/PageHeader";
import AddCustomerModal from "../components/customerManager/AddCustomerModal";
import { getCustomers, getCustomersStats } from "../services/customerService";
import { Loader } from "../components/common/Loader";

// const statCards = [
//   {
//     id: "cmTotalReceivable",
//     label: "Total Recievable",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
//   {
//     id: "cmTotalPayable",
//     label: "Total Payable",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
//   {
//     id: "cmTotalCustomers",
//     label: "Total Customers",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
//   {
//     id: "cmActiveCustomers",
//     label: "Active Customers",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
//   {
//     id: "cmPendingPayments",
//     label: "Pending Payments",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
//   {
//     id: "cmTotalGold",
//     label: "Total Gold (g)",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
//   {
//     id: "cmTotalSilver",
//     label: "Total Silver (g)",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
//   {
//     id: "cmTotalTransactions",
//     label: "Total Transactions",
//     color: "#A87506",
//     value: "Rs. 0",
//   },
// ];

// const activityData = {
//   labels: ["Receivable Customers", "Payable Customers", "No Transaction"],
//   values: [50, 50, 0],
//   colors: ["#22c55e", "#ef4444", "#9e9e9e"],
// };

const customerSatisfication = {
  labels: ["😊 Satisfied", "😐 Neutral", "😞 Unsatisfied"],
  values: [1, 1, 1],
  colors: ["#22c55e", "#ef4444", "#9e9e9e"],
};
export default function CustomerManager() {
  const [showModal, setShowModal] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({});
  const [loadingStats, setLoadingStats] = useState(false);

  useEffect(() => {
    fetchCustomers();
    getStats();
  }, []);

  // Fetching customers from API
  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const customers = await getCustomers();
      const customerList = customers?.customers || [];
      // console.log(
      //   "Fetched Customers:",
      //   customerList.find((c) => c._id === "69b01a1f3a5390ffc855c858"),
      // );
      setCustomers(customerList);
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStats = async () => {
    setLoadingStats(true);
    try {
      const response = await getCustomersStats();
      // console.log(response);
      if (response) {
        setStats(response);
      }
    } catch (err) {
    } finally {
      setLoadingStats(false);
    }
  };

  const handleSaveCustomer = (customerData) => {
    // console.log("Customer Data:", customerData);
    // Add customer in front of the list
    setCustomers((prev) => [customerData, ...prev]);
    getStats();
  };

  // console.log({ stats });
  return (
    <>
      <PageHeader />
      {/* Add Button */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex align-items-center justify-content-end mt-3">
            <button
              className="btn btn-primary"
              onClick={() => setShowModal(true)}
            >
              + Add Customer
            </button>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="row">
              {/* Stats here */}
              {loadingStats ? (
                <Loader />
              ) : (
                <StatsCard stats={stats?.statCards ?? []} />
              )}
              <CustomerTable
                customers={customers}
                isLoading={loading}
                setCustomers={setCustomers}
                refreshStats={getStats}
              />
            </div>
          </div>
          <div className="col-12 col-md-4 pt-3 satisfyChart shadow my-2">
            <div className="d-flex align-items-center justify-content-between py-4">
              <div className="col text-start textStatics">Statistics</div>
              <div className="col text-start">
                <label htmlFor="showing"> Showing </label>
                <select
                  name="selectStatis"
                  id="selectStatis"
                  className="form-control selectForm"
                >
                  <option value="thisMonth">This Month</option>
                  <option value="">This Year</option>
                </select>
              </div>
            </div>
            <div className="col-12 pt-2 d-flex align-items-center justify-content-center flex-column">
              {/* Her comes the ACtivity chart */}
              {loadingStats ? (
                <Loader />
              ) : (
                <ActivityChart data={stats?.activityData} />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container my-5">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="countryMapBack ps-1 pe-1 shadow py-5">
              <div className="d-flex align-items-center justify-content-between">
                <div className="col customerText">Customer By Country</div>
                <div className="col d-flex">
                  <label htmlFor="month" className="me-1">
                    Month
                  </label>
                  <br />
                  <select
                    name="countryMonth"
                    id="countryMonth"
                    className="form-control w-50"
                  >
                    <option value={1}>January</option>
                    <option value={2}>Febuary</option>
                    <option value={3}>March</option>
                    <option value={4}>April</option>
                    <option value={5}>May</option>
                    <option value={6}>June</option>
                    <option value={7}>July</option>
                    <option value={8}>August</option>
                    <option value={9}>September</option>
                    <option value={10}>Octuber</option>
                    <option value={11}>November</option>
                    <option value={12}>December</option>
                  </select>
                  <label htmlFor="countrySelect" className="ms-2 me-1">
                    Country
                  </label>
                  <select
                    name="countrySelect"
                    id="countrySelect"
                    className="form-control w-50"
                  >
                    <option value={2025}>2025</option>
                    <option value={2026}>2026</option>
                    <option value={2027}>2027</option>
                  </select>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="col">
                  <img src={globeImage} className="img-fluid" alt="" />
                </div>
                <div className="col text-end me-3 mt-2 d-flex flex-column">
                  <div className="oneBox">
                    <div className="orderCount">24,000</div>
                    <div className="orderText">Total Orders</div>
                  </div>
                  <div className="twoBox">
                    <div className="orderCount">24,000</div>
                    <div className="orderText">Total Delievered</div>
                  </div>
                  <div className="threeBox">
                    <div className="orderCount">24,000</div>
                    <div className="orderText">Processing</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="customer-satisfaction-card">
              <h3>Customer Satisfaction</h3>
              <ActivityChart data={customerSatisfication} />
            </div>
          </div>
        </div>
      </div>

      {/* Add Customer Modal */}

      <AddCustomerModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSaveCustomer}
      />
    </>
  );
}

// {showModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "rgba(0,0,0,0.5)",
//             zIndex: 2000,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: "8px",
//               width: "90%",
//               maxWidth: "500px",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 background: "#A87506",
//                 color: "#fff",
//                 padding: "15px 20px",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//               }}
//             >
//               <h5 className="mb-0" style={{ fontFamily: "Inria Serif" }}>
//                 Add Customer
//               </h5>
//               <button
//                 style={{
//                   background: "none",
//                   border: "none",
//                   color: "#fff",
//                   fontSize: "1.5rem",
//                   cursor: "pointer",
//                 }}
//                 onClick={() => setShowModal(false)}
//               >
//                 ×
//               </button>
//             </div>
//             <div style={{ padding: "20px" }}>
//               <div className="mb-3">
//                 <label className="form-label">Customer Name *</label>
//                 <input
//                   className="form-control"
//                   value={form.name}
//                   onChange={(e) => setForm({ ...form, name: e.target.value })}
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Phone</label>
//                 <input
//                   className="form-control"
//                   value={form.phone}
//                   onChange={(e) => setForm({ ...form, phone: e.target.value })}
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Address</label>
//                 <input
//                   className="form-control"
//                   value={form.address}
//                   onChange={(e) =>
//                     setForm({ ...form, address: e.target.value })
//                   }
//                 />
//               </div>
//               <div className="mb-3">
//                 <label className="form-label">Type</label>
//                 <select
//                   className="form-control"
//                   value={form.type}
//                   onChange={(e) => setForm({ ...form, type: e.target.value })}
//                 >
//                   <option>Gold</option>
//                   <option>Silver</option>
//                   <option>Both</option>
//                 </select>
//               </div>
//               <div className="d-flex justify-content-end gap-2">
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="btn"
//                   style={{ background: "#A87506", color: "#fff" }}
//                   onClick={() => {
//                     alert("add customer");
//                   }}
//                 >
//                   Add Customer
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
